<template>
  <div class="nav-bar">
    <v-app-bar app flat elevate-on-scroll fixed>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="grey--text">
        <!-- <span class="font-weight-light">NotaFiscal</span>
        <span class="font-weight-medium">Avulsa</span>-->
        <img src="@/assets/logoDec.png" alt="Logo" height="50" />
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-xs-only">
        <v-btn
          small
          text
          v-for="link in links"
          :key="link.text"
          router
          :to="link.route"
        >
          <span>{{ link.text }}</span>
        </v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
<!--            <v-btn small text v-on="on">-->
<!--              Consultas-->
<!--              <v-icon small right>keyboard_arrow_down</v-icon>-->
<!--            </v-btn>-->
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in items"
              :key="index"
              router
              :to="item.route"
            >
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
      <!-- <v-btn
        small
        outlined
        color="#006eb8"
        class="mx-2 hidden-xs-only"
        target="_blank"
        :href="linkCadastro"
        >Cadastro</v-btn
      > -->
      <v-btn
        depressed
        small
        dark
        color="#006eb8"
        class="mx-2 hidden-xs-only"
        route
        :to="linkLogin"
        >Entrar</v-btn
      >
    </v-app-bar>

    <v-navigation-drawer app temporary v-model="drawer" color="#006eb8">
      <v-list>
        <v-list-item
          v-for="link in linksDrawer"
          :key="link.text"
          router
          :to="link.route"
        >
          <v-list-item-icon>
            <v-icon class="white--text">{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="white--text">
            {{ link.text }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      drawer: false,
      linkLogin: "/login",
      linkCadastro: "",
      items: [
        // { icon: "done_all", text: "Autenticidade", route: "/autenticidade" },
        // { icon: "folder", text: "Legislação", route: "/legislacao" },
        // { icon: "folder", text: "RPS-Lote", route: "/lote" },
        // {
        //   icon: "folder",
        //   text: "Empresas autorizadas à emissão",
        //   route: "/empresa",
        // },
      ],
      linkCredenciamento: "/credenciamento",
      linksDrawer: [
        { icon: "home", text: "Inicial", route: "/" },
        { icon: "account_circle", text: "Acessar", route: "/login" },
        // { icon: "lock", text: "Recuperar senha", route: "/senha" },
        // { icon: "history", text: "Recuperar Email", route: "/recuperarEmail" },
         { icon: "folder", text: "Legislação", route: "/legislacao" },
        { icon: "live_help", text: "Ajuda", route: "/ajuda" },
        // { icon: "question_answer", text: "Fale Conosco", route: "/contato" },
        // {
        //   icon: "account_balance",
        //   text: "Empresas autorizadas",
        //   route: "/empresa",
        // },
      ],
      links: [
        { icon: "home", text: "Inicial", route: "/" },
        { icon: "live_help", text: "Ajuda", route: "/ajuda" },
        { icon: "folder", text: "Legislação", route: "/legislacao" },
        // { icon: "question_answer", text: "Fale Conosco", route: "/contato" },
      ],
    };
  },
  created() {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const port = window.location.port == "8081" ? "8080" : window.location.port;
    //const base_URL = `${protocol}//${hostname}:${port}/dec/paginas/credenciamento/listaCredenciamento.jsf`;
    const base_URL = `${protocol}//${hostname}:${port}/controleacesso/paginas/usuario/listaUsuarioExterno.jsf?multiTenantId=11&mostraCampoMatricula=N&faces-redirect=true`;
    this.linkCadastro = base_URL;
  },
};
</script>

<style scoped></style>
